import React, { useState } from "react";
import { toast } from "sonner";
import { supabase } from "@/auth/AuthContext";

export default function CreateWeddingDialog({ open, onClose, onCreated }) {
  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");
  const [location, setLocation] = useState("");
  const [welcome, setWelcome] = useState("");
  const [loading, setLoading] = useState(false);

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (!title.trim() || title.trim().length < 2) {
      toast.error("Inserisci un titolo");
      return;
    }
    setLoading(true);
    try {
      const { data: authData } = await supabase.auth.getUser();
      const slug = title.trim()
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9-]/g, "")
        + "-" + Date.now();

      const { data, error } = await supabase
        .from("weddings")
        .insert({
          owner_id: authData.user.id,
          title: title.trim(),
          slug,
          wedding_date: date || null,
          location: location.trim() || null,
        })
        .select()
        .single();

      if (error) throw error;
      toast.success("Matrimonio creato");
      onCreated?.(data);
      onClose?.();
      // reset
      setTitle("");
      setDate("");
      setLocation("");
      setWelcome("");
    } catch (err) {
      const msg = err?.message ?? "";
      if (msg.includes("Quota eventi esaurita")) {
        toast.error("Hai raggiunto il limite di eventi per il tuo piano.");
      } else {
        toast.error("Errore nella creazione");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="create-wedding-dialog"
      className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-5"
      onClick={onClose}
    >
      <form
        onClick={(e) => e.stopPropagation()}
        onSubmit={submit}
        className="bg-white w-full max-w-lg rounded-[14px] border border-neutral-200 p-8 md:p-10"
      >
        <div className="text-[11px] tracking-[0.22em] uppercase text-neutral-500 mb-3">
          Nuovo matrimonio
        </div>
        <h2 className="font-display text-[30px] md:text-[36px] tracking-[-0.02em] font-light text-neutral-950">
          Crea il tuo matrimonio
        </h2>
        <p className="mt-3 text-[14px] text-neutral-600">
          Pochi dettagli e la tua galleria sarà pronta.
        </p>

        <div className="mt-8 space-y-5">
          <div>
            <label className="text-[11px] tracking-[0.18em] uppercase text-neutral-500">
              Titolo / Nomi degli sposi
            </label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              data-testid="wedding-title-input"
              placeholder="Giulia & Marco"
              className="mt-2 w-full bg-white border border-neutral-200 rounded-[10px] px-4 py-3 text-[15px] outline-none focus:border-[color:var(--wf-gold)]"
              required
              minLength={2}
              maxLength={120}
              autoFocus
            />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <div>
              <label className="text-[11px] tracking-[0.18em] uppercase text-neutral-500">
                Data
              </label>
              <input
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                data-testid="wedding-date-input"
                className="mt-2 w-full bg-white border border-neutral-200 rounded-[10px] px-4 py-3 text-[15px] outline-none focus:border-[color:var(--wf-gold)]"
              />
            </div>
            <div>
              <label className="text-[11px] tracking-[0.18em] uppercase text-neutral-500">
                Luogo
              </label>
              <input
                type="text"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                data-testid="wedding-location-input"
                placeholder="Toscana, Italia"
                className="mt-2 w-full bg-white border border-neutral-200 rounded-[10px] px-4 py-3 text-[15px] outline-none focus:border-[color:var(--wf-gold)]"
                maxLength={200}
              />
            </div>
          </div>
          <div>
            <label className="text-[11px] tracking-[0.18em] uppercase text-neutral-500">
              Messaggio di benvenuto
            </label>
            <textarea
              value={welcome}
              onChange={(e) => setWelcome(e.target.value)}
              data-testid="wedding-welcome-input"
              placeholder="Bentornati al nostro grande giorno…"
              rows={3}
              className="mt-2 w-full bg-white border border-neutral-200 rounded-[10px] px-4 py-3 text-[15px] outline-none focus:border-[color:var(--wf-gold)] resize-none"
              maxLength={600}
            />
          </div>
        </div>

        <div className="mt-10 flex items-center justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            data-testid="wedding-cancel-btn"
            className="wf-btn-ghost border border-neutral-200 rounded-full px-5 py-2.5 text-[13px] tracking-wide"
          >
            Annulla
          </button>
          <button
            type="submit"
            disabled={loading}
            data-testid="wedding-create-btn"
            className="wf-btn-primary rounded-full px-6 py-2.5 text-[13px] tracking-wide disabled:opacity-60"
          >
            {loading ? "Creazione…" : "Crea matrimonio"}
          </button>
        </div>
      </form>
    </div>
  );
}
